import React from 'react';
import { TIER_SWITCH_BLOCKED_REASON } from '../../constants/TierSwitch';
import {
	SUBSCRIPTION_TIER_CHANGE_IS_IN_PERIOD_WITH_FIXED_TIER,
	SUBSCRIPTION_TIER_CHANGE_PENDING,
	SUBSCRIPTION_TIER_CHANGE_HAS_VOUCHER_OR_PROMOTION,
	SUBSCRIPTION_TIER_CHANGE_SUBSCRIPTION_CANCELLED,
	SUBSCRIPTION_TIER_CHANGE_TOO_EARLY_TO_SWITCH,
	SUBSCRIPTION_TIER_CHANGE_HAS_TRUSTED_PARTY,
	UNKNOWN,
	TIER_SWITCH_BLOCKED_REASON_UNKNOWN,
} from '../../constants/Copy';
import { getPresentationForTier } from '../../helpers/tiers';
import { friendlyDate, simpleDate } from '../../helpers/datetime';
import { TRUSTED_PARTIES } from '../../constants/ResellersAndPartners';
import { YOUR_TV_PROVIDER } from '../../constants/Copy';

export const SwitchBlockedReasonMessage = ({
	planId,
	tierSwitch,
	nextTier,
	subscriptionGraphQlDetails,
	isThirdParty,
}) => {
	let { switchBlockedReason, switchAvailableDate } = tierSwitch;

	// Trusted-Party subscriptions can only be switched -or- cancelled via the provider
	if (isThirdParty) {
		switchBlockedReason = TIER_SWITCH_BLOCKED_REASON.IS_TRUSTED_PARTY_SUBSCRIPTION;
	}

	switch (switchBlockedReason) {
		case TIER_SWITCH_BLOCKED_REASON.SUBSCRIPTION_CANCELLED:
			return <p>{SUBSCRIPTION_TIER_CHANGE_SUBSCRIPTION_CANCELLED}</p>;
		case TIER_SWITCH_BLOCKED_REASON.IS_IN_PERIOD_WITH_FIXED_TIER:
			return <p>{SUBSCRIPTION_TIER_CHANGE_IS_IN_PERIOD_WITH_FIXED_TIER}</p>;
		case TIER_SWITCH_BLOCKED_REASON.TIER_CHANGE_PENDING:
			return getTierChangePendingHtml(switchAvailableDate, nextTier.tierId, nextTier.effectiveDate);
		case TIER_SWITCH_BLOCKED_REASON.HAS_ACTIVE_TERMED_VOUCHER:
		case TIER_SWITCH_BLOCKED_REASON.RESELLER_EXCLUDED_FROM_SWITCHING:
			return <p>{SUBSCRIPTION_TIER_CHANGE_HAS_VOUCHER_OR_PROMOTION}</p>;
		case TIER_SWITCH_BLOCKED_REASON.TOO_EARLY_TO_SWITCH:
			return (
				<p>
					{SUBSCRIPTION_TIER_CHANGE_TOO_EARLY_TO_SWITCH.replace(
						'{datum}',
						simpleDate(switchAvailableDate)
					)}
				</p>
			);
		case TIER_SWITCH_BLOCKED_REASON.IS_TRUSTED_PARTY_SUBSCRIPTION:
		case TIER_SWITCH_BLOCKED_REASON.SWITCH_NOT_ALLOWED:
			return (
				<p>
					{SUBSCRIPTION_TIER_CHANGE_HAS_TRUSTED_PARTY.replace(
						/{trustedParty}/g,
						getTrustedPartyDisplayName(subscriptionGraphQlDetails, planId)
					)}
				</p>
			);
		default:
			return <p>{TIER_SWITCH_BLOCKED_REASON_UNKNOWN}</p>;
	}
};

function getTrustedPartyDisplayName(subscriptionGraphQlDetails, planId) {
	if (planId === 'TrustedPartyKpnPlus') {
		return YOUR_TV_PROVIDER;
	}

	const trustedPartyDisplayName = TRUSTED_PARTIES.find(
		(trustedParty) =>
			trustedParty.trustedPartyId === subscriptionGraphQlDetails?.details?.data?.trustedParty
	)?.displayName;

	return trustedPartyDisplayName || UNKNOWN;
}

function getTierChangePendingHtml(switchAvailableDate, tierId, effectiveDate) {
	const [segmentOne, segmentTwo, segmentThree] = SUBSCRIPTION_TIER_CHANGE_PENDING;
	return (
		<p>
			{segmentOne}
			<strong>{getPresentationForTier(tierId).title}</strong>
			{segmentTwo}
			<strong>{friendlyDate(effectiveDate)}</strong>
			{segmentThree}
			<strong>{friendlyDate(switchAvailableDate)}.</strong>
		</p>
	);
}
